import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Row,
} from "reactstrap";
import { IUserMeeting } from "../../app/models/meeting";
import { RootStoreContext } from "../../app/stores/rootStore";
import classNames from "classnames";
import SaveOfflineMeetingButton from "../buttons/SaveOfflineMeetingButton";
import { ITenant } from "../../app/models/tenant";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

interface IParams {
  meeting: IUserMeeting;
  tenant: ITenant;
  toListOrNot: boolean;
}
//#region "cssClass" (Declaration of class used to switch cssCards to cssList);
export class cssMeeting {
  divContainer: string;
  card: string;
  cardHeader: cardHeaderClass;
  cardBody: cardBodyClass;
  cardFooter: cardFooterClass;
  constructor(divContainer:string, card:string, cardHeader:cardHeaderClass, cardBody:cardBodyClass,cardFooter:cardFooterClass) {
    this.divContainer = divContainer;
    this.card = card;
    this.cardHeader = cardHeader;
    this.cardBody = cardBody;
    this.cardFooter = cardFooter;
  }
}
export class cardHeaderClass {
  header:string ;
  podiumCol:string;
  podiumIcon:string;
  activeIcon:string;
  constructor(header:string,podiumCol:string,podiumIcon:string,activeIcon:string){
this.header=header;
this.podiumCol=podiumCol;
this.podiumIcon=podiumIcon;
this.activeIcon=activeIcon;
  }
}
export class cardBodyClass {
  body:string ;
  row_1:string ;
  text_1:string;
  centralDiv:string;
  row_2:string;
  text_2:string;
  row_3:string;
  text_3:string;
  row_4:string;
  text_4:string;
  constructor(body:string,row_1:string,text_1:string,centralDiv:string,row_2:string,text_2:string,row_3:string,text_3:string,row_4:string,text_4:string){
this.body=body;
this.row_1=row_1;
this.text_1=text_1;
this.centralDiv=centralDiv;
this.row_2=row_2;
this.text_2=text_2;
this.row_3=row_3;
this.text_3=text_3;
this.row_4=row_4;
this.text_4=text_4;
  }
}
export class cardFooterClass {
  footer : string;
  row_1 : string;
  col_1 : string;
  button_1 : string;
  col_2 : string;
  button_2 : string;
  col_3 : string;
  constructor(footer:string,row_1:string,col_1:string,button_1:string,col_2:string,button_2:string,col_3:string){
this.footer=footer;
this.row_1=row_1;
this.col_1=col_1;
this.button_1= button_1;
this.col_2=col_2;
this.button_2=button_2;
this.col_3=col_3;
  }
}
//#endregion

const MeetingCard: React.FC<IParams> = ({ meeting, tenant, toListOrNot }) => {
  const rootStore = useContext(RootStoreContext);
  const { showMeetingAttendanceModal , enabledRepository} = rootStore.playerStore;
  const { isNativeApp, companyTheme } = rootStore.commonStore;
const {canViewODG}= rootStore.tenantStore;
  const startDateObj = moment(meeting.startDate);
  const endDateObj = moment(meeting.endDate);
  const currentDateObj = moment();
  const link = canViewODG ? `meeting/${meeting.id}` : ( enabledRepository ? `repository` : `board`);
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["translation", "dateCustom"], translationHookOptions);
  var css : cssMeeting;

  const [isTabletPortrait, setIsTabletPortrait] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isPortrait = window.innerHeight > window.innerWidth;
      // const isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;
      const isTablet = window.innerWidth <= 1024;
      setIsTabletPortrait(isPortrait || isTablet);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Verifica immediatamente

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const cssCard : cssMeeting = new cssMeeting(
    "mt-4",
    "",
    new cardHeaderClass("meetingCardHeaderFooter","col-2Podium","fas fa-podium fa-lg py-2 podiumMargin","fas fa-circle ml-2 mr-2"),
    new cardBodyClass("meetingCardBody","justify-content-center mb-2","meetingCardTitle","","","","","","",""),
    new cardFooterClass("meetingCardHeaderFooter","","col-2Download","bg-white downloadBtn","joinBtn","meetingCardButton","col-2Podium")
    );
  const cssCardList : cssMeeting =new cssMeeting(
    "mt-4List",
    "rowView",
    new cardHeaderClass("meetingCardHeaderFooter meetingHeaderList","col-2ListPodium","fas fa-podium fa-lg py-2","fas fa-circle ml-2 mr-2 headerIconList"),
    new cardBodyClass("ListMeetingCardBody rowView","listCellTitle","meetingCardTitle h5","divDataOra","listCell listCell_Data","h6","listCell width25","h6","listCell width10","h6"),
    new cardFooterClass("meetingCardHeaderFooter listCellBtn"+((!isNativeApp)?(" autoWidth"):""),"width100ZeroMargin"+((!isNativeApp)?(" width50"):""),"col-2ListDownload"+((!isNativeApp)?(" displayNone"):""),"downloadBtnList bg-white listMeetingCardButton","joinBtnList","listMeetingCardButton","col-2ListPodium")
    );

  css=(!toListOrNot)? cssCard : cssCardList;

  const handleInProgressMeeting = (
    e: React.MouseEvent<HTMLElement, MouseEvent>
  ) => {
    showMeetingAttendanceModal(meeting);
  };

  const duration = toListOrNot || companyTheme?.hiddenDuration ? "" : (" (" + 
  (((endDateObj.diff(startDateObj, "hours")) < 24)?
   (endDateObj.diff(startDateObj, "hours")) +"h)"
   :
   (endDateObj.diff(startDateObj, "days")) +`${t("meeting_card_abbreviated_day")}`+")" ));

  // const meetingStartEndHours = (
  //   <div>
  //     <h6 className={css.cardBody.text_3}>
  //       {!isTabletPortrait ?
  //         t("meeting_card_startend", {
  //           start_time: startDateObj.format("HH:mm"),
  //           end_time:  endDateObj.format("HH:mm"),
  //         }) + duration 
  //         :
  //         t("meeting_card_startonly", {
  //           start_time: startDateObj.format("HH:mm"),
  //         }) + duration
  //       }
  //     </h6>
  //   </div>
  // );

  // const meetingStartHours = (
  //   <div>
  //     <h6 className={css.cardBody.text_3}>
  //       {t("meeting_card_startonly", {
  //         start_time: startDateObj.format("HH:mm"),
  //       }) + duration}
  //     </h6>
  //   </div>
  // );


  // const meetingEndHours = (
  //   <div>
  //     <h6 className={css.cardBody.text_3}>
  //       {t("meeting_card_startonly", {
  //         start_time: endDateObj.format("HH:mm"),
  //       }) + duration}
  //     </h6>
  //   </div>
  // );

  const meetingStartEndHours = (
    <div>
      <h6 className={css.cardBody.text_3}>
        {!isTabletPortrait ?
          t("meeting_card_startend", {
            start_time: t("time", {
              ns:"dateCustom",
              hour24: moment(startDateObj).format("HH"),
              hour12: moment(startDateObj).format("hh"),
              minute: moment(startDateObj).format("mm"),
              ampm:moment(startDateObj).format("A")
            }),
            end_time: t("time", {
              ns:"dateCustom",
              hour24: moment(endDateObj).format("HH"),
              hour12: moment(endDateObj).format("hh"),
              minute: moment(endDateObj).format("mm"),
              ampm: moment(endDateObj).format("A")
            }),
          }) + duration 
          :
          t("meeting_card_startonly", {
            start_time:t("time", {
              ns:"dateCustom",
              hour24: moment(startDateObj).format("HH"),
              hour12: moment(startDateObj).format("hh"),
              minute: moment(startDateObj).format("mm"),
              ampm: moment(startDateObj).format("A")
            }),
          }) + duration
        }
      </h6>
    </div>
  );

  const meetingStartHours = (
    <div>
      <h6 className={css.cardBody.text_3}>
        {t("meeting_card_startonly", {
          start_time: t("time", {
            ns:"dateCustom",
            hour24:  moment(startDateObj).format("HH"),
            hour12:  moment(startDateObj).format("hh"),
            minute:  moment(startDateObj).format("mm"),
            ampm:  moment(startDateObj).format("A")
          }),
        }) + duration}
      </h6>
    </div>
  );
  
  const meetingEndHours = (
    <div>
      <h6 className={css.cardBody.text_3}>
        {t("meeting_card_startonly", {
          start_time: t("time", {
            ns:"dateCustom",
            hour24: moment(endDateObj).format("HH"),
            hour12:moment(endDateObj).format("hh"),
            minute: moment(endDateObj).format("mm"),
            ampm: moment(endDateObj).format("A")
          }),
        }) + duration}
      </h6>
    </div>
  );
  const OfflineDownloadBtn = (
    <>
      {isNativeApp && (
          <SaveOfflineMeetingButton
            meeting={meeting}
            tenant={tenant}
            cardType={"presente"}
            btnClassName={css.cardFooter.button_1}
          />
      )}
    </>
  )
  const podiumIconDiv = (
    <Col sm={2} style={{height:34 }} className={css.cardHeader.podiumCol}>
      {meeting.hasEnabledPodium && (
        <i
          className={classNames(css.cardHeader.podiumIcon,
            `${theme?.meetingCardActiveTextColor}`
          )}
        ></i>
      )}
    </Col>
  )

  return (
    <div className={css.divContainer}>
      {currentDateObj.isBetween(startDateObj, endDateObj) ||
      currentDateObj.isSame(endDateObj, "day") ? (
        <Card
          className={classNames(css.card,
            "meetingCard",
            `${theme?.meetingCardActiveColor} ${theme?.meetingCardActiveBorderColor}`
          )}
        >
          
          <CardHeader className={css.cardHeader.header}>
            <div className="row">
            {(!toListOrNot) && podiumIconDiv}
              {currentDateObj.isBetween(startDateObj, endDateObj) ? (
                <div className={classNames(
                  "d-inline-flex",
                  `${!toListOrNot? "status" : "statusOnApp"}`
                )}>
                  {(!toListOrNot)?
                  <h6 className={classNames(
                      "text-danger",
                      `${theme?.currentMeetingTextColor}`
                    )}
                  >
                    {t("meeting_card_inprogress")}
                  </h6>
                  : null
                    }
                  <i
                    className={classNames(css.cardHeader.activeIcon,
                      `${theme?.currentMeetingIconColor}`
                    )}
                  ></i>
                </div>
              ) : (
                <br></br>
              )}
            </div>
          </CardHeader>
          <CardBody className={css.cardBody.body} >
            <Row
              className={classNames(css.cardBody.row_1,
                `${theme?.meetingCardActiveTextColor}`
              )}
            >
              <h5 className={css.cardBody.text_1}>
                <b>{meeting.title}</b>
              </h5>
            </Row>
            <div className={css.cardBody.centralDiv}>
            <Row
              className={classNames(css.cardBody.row_2,
                "justify-content-center ",
                `${theme?.meetingCardActiveTextColor}`
              )}
            >
              {/* <h6 className={css.cardBody.text_2}>
                <b>{(companyTheme?.hiddenStartDate)? "" : startDateObj.format("DD.MM.YYYY")}</b>
                <b>{(!companyTheme?.hiddenEndDate && !companyTheme?.hiddenStartDate && !isTabletPortrait)? " - " : " "}</b>
                 <b>{(companyTheme?.hiddenEndDate || isTabletPortrait)? "" : endDateObj.format("DD.MM.YYYY")}</b>
              </h6> */}
               <h6 className={css.cardBody.text_2}>
                <b>{(companyTheme?.hiddenStartDate)? "" : 
               t("date_translation_option" , {ns:"dateCustom",  month:  moment(startDateObj).format("MM"), day:  moment(startDateObj).format("DD"), year: moment(startDateObj).format("YYYY") })
                }
                </b>
                <b>{(!companyTheme?.hiddenEndDate && !companyTheme?.hiddenStartDate && !isTabletPortrait)? " - " : " "}</b>
                 <b>{(companyTheme?.hiddenEndDate || isTabletPortrait)? "" :  
                   t("date_translation_option" , {ns:"dateCustom",  month:  moment(endDateObj).format("MM"), day:  moment(endDateObj).format("DD"), year: moment(endDateObj).format("YYYY") })
                }
                 </b>
              </h6>
              
            </Row>
            <Row
              className={classNames(css.cardBody.row_3,
                "justify-content-center ",
                `${theme?.meetingCardActiveTextColor}`
              )}
            >
               { (!companyTheme?.hiddenEndHour && !companyTheme?.hiddenStartHour)
                ? meetingStartEndHours
                : (companyTheme?.hiddenEndHour && !companyTheme?.hiddenStartHour)
                ? meetingStartHours
                : (!companyTheme?.hiddenEndHour && companyTheme?.hiddenStartHour )
                ? meetingEndHours 
                : (companyTheme?.hiddenEndHour && companyTheme?.hiddenStartHour)
                ? "" : meetingStartEndHours}
            </Row> 
            </div>
            <Row
              className={classNames(css.cardBody.row_4,
                "justify-content-center ",
                `${theme?.meetingCardActiveTextColor}`
              )}
            >
              <div>
                <h6 className={css.cardBody.text_4}>
                  {(companyTheme?.hiddenNumDoc || !canViewODG)? "" :`(${t("meeting_card_doc_num", {
                  doc_num: meeting.documentsCount,
                  })})`}
                </h6>
              </div>
            </Row>
          </CardBody>
        
            <CardFooter className={css.cardFooter.footer}>
          <Row className= {css.cardFooter.row_1}>
        <Col sm={2} className={css.cardFooter.col_1}> {OfflineDownloadBtn} </Col>
              <Col sm={8} className={css.cardFooter.col_2}>
                <Button
                  className={classNames(css.cardFooter.button_2,
                    `${theme!.meetingCardActiveButtonColor} ${
                      theme!.meetingCardActiveButtonTextColor
                    }`
                  )}
                  onClick={(e) => handleInProgressMeeting(e)}
                >
                  {t("meeting_card_enter")}
                </Button>
              </Col>
              {(!toListOrNot)? 
              <Col sm={2} ></Col>
              :
              podiumIconDiv}
         
            </Row>
          </CardFooter>
          
         
        </Card>
      ) : currentDateObj.isBefore(startDateObj) ? (
        <Card
          className={classNames(css.card,
            "meetingCard",
            `${theme?.meetingCardFutureColor} ${theme?.meetingCardFutureBorderColor}`
          )}
        >
          <CardHeader className={css.cardHeader.header}>
            {!toListOrNot && (<Row><div style={{height:34 }}></div></Row>)}
          </CardHeader>
          <CardBody className={css.cardBody.body}>
            <Row
              className={classNames(css.cardBody.row_1,
                `${theme?.meetingCardFutureTextColor}`
              )}
            >
              <h5 className={css.cardBody.text_1}>
                {" "}
                <b>{meeting.title}</b>
              </h5>
            </Row>
            <div className={css.cardBody.centralDiv}>
            <Row
              className={classNames(css.cardBody.row_2,
                "justify-content-center ",
                `${theme?.meetingCardFutureTextColor}`
              )}
            >
              {/* <h6 className={css.cardBody.text_2}>
                <b>{(companyTheme?.hiddenStartDate)? "" : startDateObj.format("DD.MM.YYYY")}</b>
                <b>{(!companyTheme?.hiddenEndDate && !companyTheme?.hiddenStartDate && !isTabletPortrait)? " - " : " "}</b>
                <b>{(companyTheme?.hiddenEndDate || isTabletPortrait)? "" : endDateObj.format("DD.MM.YYYY")}</b>
              </h6> */}
            <h6 className={css.cardBody.text_2}>
                <b>{(companyTheme?.hiddenStartDate)? "" : 
               t("date_translation_option" , {ns:"dateCustom",  month:  moment(startDateObj).format("MM"), day:  moment(startDateObj).format("DD"), year: moment(startDateObj).format("YYYY") })
                }
                </b>
                <b>{(!companyTheme?.hiddenEndDate && !companyTheme?.hiddenStartDate && !isTabletPortrait)? " - " : " "}</b>
                 <b>{(companyTheme?.hiddenEndDate || isTabletPortrait)? "" :  
                   t("date_translation_option" , {ns:"dateCustom",  month:  moment(endDateObj).format("MM"), day:  moment(endDateObj).format("DD"), year: moment(endDateObj).format("YYYY") })
                }
                 </b>
              </h6>
            </Row>
            <Row
              className={classNames(css.cardBody.row_3,
                "justify-content-center ",
                `${theme?.meetingCardFutureTextColor}`
              )}
            >
               { (!companyTheme?.hiddenEndHour && !companyTheme?.hiddenStartHour)
                ? meetingStartEndHours
                : (companyTheme?.hiddenEndHour && !companyTheme?.hiddenStartHour)
                ? meetingStartHours
                : (!companyTheme?.hiddenEndHour && companyTheme?.hiddenStartHour )
                ? meetingEndHours 
                : (companyTheme?.hiddenEndHour && companyTheme?.hiddenStartHour)
                ? "" : meetingStartEndHours}
            </Row>
            </div>
            <Row
              className={classNames(css.cardBody.row_4,
                "justify-content-center ",
                `${theme?.meetingCardFutureTextColor}`
              )}
            >
              <div>
                <h6 className={css.cardBody.text_4}>
                  {(companyTheme?.hiddenNumDoc || !canViewODG)? "" :`(${t("meeting_card_doc_num", {
                  doc_num: meeting.documentsCount,
                  })})`}
                </h6>
              </div>
            </Row>
          </CardBody>
          <CardFooter className={css.cardFooter.footer}>
            
            
              <Row className= {css.cardFooter.row_1}>
            
                <Col sm={2} className={css.cardFooter.col_1}> {OfflineDownloadBtn} </Col>
              <Col sm={8} className={css.cardFooter.col_2}>
                  <Link to={link}  style={{ pointerEvents: canViewODG ? "auto" : "none" }}>
                  <Button
                   style={{ visibility: canViewODG ? "visible" : "hidden" }}
                    className={classNames(css.cardFooter.button_2,
                      `${theme!.meetingCardFutureButtonColor} ${
                        theme!.meetingCardFutureButtonTextColor
                      }`
                    )}
                  >
                    {t("meeting_card_enter")}
                  </Button>
                </Link> 
              
              </Col>
              <Col sm={2}  className={css.cardFooter.col_3}/>
             
            </Row>
            
         
          </CardFooter>
        </Card>
      ) : (
        <Card
          className={classNames(css.card,
            "meetingCard",
            `${theme?.meetingCardPastColor} ${theme?.meetingCardPastBorderColor}`
          )}
        >
          <CardHeader className={css.cardHeader.header}>
          {!toListOrNot && (<Row><div style={{height:33.99 }}></div></Row>)}
          </CardHeader>
          <CardBody className={css.cardBody.body}>
            <Row
              className={classNames(css.cardBody.row_1,
                `${theme?.meetingCardPastTextColor}`
              )}
            >
              <h5 className={css.cardBody.text_1}>
                {" "}
                <b>{meeting.title}</b>
              </h5>
            </Row>
            <div className={css.cardBody.centralDiv}>
            <Row
              className={classNames(css.cardBody.row_2,
                "justify-content-center ",
                `${theme?.meetingCardPastTextColor}`
              )}
            >
              {/* <h6 className={css.cardBody.text_2}>
                <b>{(companyTheme?.hiddenStartDate)? "" : startDateObj.format("DD.MM.YYYY")}</b>
                <b>{(!companyTheme?.hiddenEndDate && !companyTheme?.hiddenStartDate && !isTabletPortrait)? " - " : " "}</b>
                <b>{(companyTheme?.hiddenEndDate || isTabletPortrait)? "" : endDateObj.format("DD.MM.YYYY")}</b>
              </h6> */}
                <h6 className={css.cardBody.text_2}>
                <b>{(companyTheme?.hiddenStartDate)? "" : 
               t("date_translation_option" , {  ns:"dateCustom", month:  moment(startDateObj).format("MM"), day:  moment(startDateObj).format("DD"), year: moment(startDateObj).format("YYYY") })
                }
                </b>
                <b>{(!companyTheme?.hiddenEndDate && !companyTheme?.hiddenStartDate && !isTabletPortrait)? " - " : " "}</b>
                 <b>{(companyTheme?.hiddenEndDate || isTabletPortrait)? "" :  
                   t("date_translation_option" , {  ns:"dateCustom", month:  moment(endDateObj).format("MM"), day:  moment(endDateObj).format("DD"), year: moment(endDateObj).format("YYYY") })
                }
                 </b>
              </h6>
            </Row>
            <Row
              className={classNames(css.cardBody.row_3,
                "justify-content-center ",
                `${theme?.meetingCardPastTextColor}`
              )}
            >
              { (!companyTheme?.hiddenEndHour && !companyTheme?.hiddenStartHour)
                ? meetingStartEndHours
                : (companyTheme?.hiddenEndHour && !companyTheme?.hiddenStartHour)
                ? meetingStartHours
                : (!companyTheme?.hiddenEndHour && companyTheme?.hiddenStartHour )
                ? meetingEndHours 
                : (companyTheme?.hiddenEndHour && companyTheme?.hiddenStartHour)
                ? "" : meetingStartEndHours}
            </Row>
            </div>
            {/* <div className={(!toListOrNot)? "" : "divDocButtons"}></div> */}
            <Row
              className={classNames(css.cardBody.row_4,
                "justify-content-center ",
                `${theme?.meetingCardPastTextColor}`
              )}
            >
              <div>
                <h6 className={css.cardBody.text_4}>
                   {(companyTheme?.hiddenNumDoc || !canViewODG )? "":
                      `(${t("meeting_card_doc_num", {
                        doc_num: meeting.documentsCount,
                      })})` 
                      }
                </h6>
              </div>
            </Row>
          </CardBody>
       
          <CardFooter className={css.cardFooter.footer}>
            <Row className= {css.cardFooter.row_1}>
                <Col sm={2} className={css.cardFooter.col_1}> {OfflineDownloadBtn} </Col>
              <Col sm={8}  className={css.cardFooter.col_2}>
                <Link to={link}   style={{ pointerEvents: canViewODG ? "auto" : "none" }}>
                  <Button
                   style={{ visibility: canViewODG ? "visible" : "hidden" }}
                    className={classNames(css.cardFooter.button_2,
                      `${theme!.meetingCardPastButtonColor} 
                  ${theme!.meetingCardPastButtonTextColor}`
                    )}
                  >
                    {t("meeting_card_enter")}
                  </Button>
                </Link>
              </Col>
              <Col sm={2} className={css.cardFooter.col_3}/>
            </Row>
          </CardFooter>
        </Card>
      )}
    </div>
  );
};

export default observer(MeetingCard);
